<template>
  <div>

    <div class="box" v-if="user && user.id">
      <div class="flex flex-wrap items-end justify-between border-b border-theme-200 light:border-theme-600 pb-2">
        <p class="text-2xl font-bold leading-none">{{ user.name }} ({{ user.roles.map(r => r.name).join(',') }})</p>
        <button type="button" class="btn btn-orange text-xs text-black" @click="$router.push('/profile/edit')">
          <i class="fas fa-edit"></i>
          <span class="ml-1">Edit</span>
        </button>
      </div>

      <div class="leading-tight">
        <p class="font-bold text-xs mt-4">Name:</p>
        <p class="text-xl">
          {{ user.name }}
        </p>

        <p class="font-bold text-xs mt-4">Email:</p>
        <p class="text-xl">
          {{ user.email }}
        </p>

        <p class="font-bold text-xs mt-4">Created at:</p>
        <p class="text-xl">
          {{ $moment(user.created_at).format(config.dateTimeFormats.display) }}
        </p>

        <p class="font-bold text-xs mt-4">Role:</p>
        <p class="text-xl">
          {{ user.roles.map(r => r.name).join(',') }}
        </p>
      </div>

    </div>

  </div>
</template>


<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      user: {},
    }
  },
  computed: {
    ...mapGetters({
      config: 'config/config',
      User: 'user/user',
    })
  },
  mounted() {
    this.get()
  },
  methods: {
    get() {
      axios.get('users/' + this.User.id)
        .then((response) => {
          this.user = Object.assign({}, response.data)
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal.fire({
            title: 'User not found',
            type: 'warning',
          })
        })
    },
  }
}
</script>
